import React, { createContext, useContext, useState } from 'react';
import GroupAssigned, { GroupAssignedProps } from './GroupAssigned';
import { PartialSpinny } from '../../../../../Nav/Spinny';

const CloseDialogContext = createContext<CloseDialogContextProps>({} as CloseDialogContextProps);
//CloseDialogContext.displayName = 'CloseDialogContext';
export const CloseDialogProvider = ({ children }) => {
  const [dialog, setDialog] = useState<GroupAssignedProps>();
  const [loading, setLoading] = useState<boolean>(false);
  const showDialog = (props) => {
    console.log('showDialog', props);
    setDialog({ ...props, show: true });
  };

  const hideDialog = () => {
    setDialog({ show: false, message: '', onClose: null });
  };

  const showLoading = (isLoading: boolean) => {
    console.log('isLoading', isLoading);
    setLoading(isLoading);
  };

  return (
    <CloseDialogContext.Provider value={{ dialog, showDialog, hideDialog, showLoading }}>
      <>
        {loading && <PartialSpinny />}
        <GroupAssigned {...dialog} />
        {children}
      </>
    </CloseDialogContext.Provider>
  );
};
export type CloseDialogContextProps = {
  dialog: GroupAssignedProps
  showDialog: (props: GroupAssignedProps) => void;
  hideDialog: () => void;
  showLoading: (isLoading: boolean) => void;
};
export const useCloseDialog = () => useContext(CloseDialogContext);